import { targetStatuses } from 'boot/globals';
import { chain, get, isEmpty, merge } from 'lodash';

export default {
  workflowStatuses: (state) => {
    if (isEmpty(state.workflows)) {
      return {
        default: targetStatuses,
      };
    }
    return chain(state.workflows)
      .keyBy('id')
      .mapValues((workflow) => (merge({}, targetStatuses, get(workflow, 'statuses', {}))))
      .set('default', targetStatuses)
      .value();
  }, // workflowStatuses()

};
